<template>
  <v-container
    style="height: 100%"
    class="d-flex justify-center align-center mt-4"
  >
    <v-snackbar dark v-model="snackbar">
      Inspection will sync when online, please go back
      <v-btn color="primary" to="/measurements"> Close </v-btn>
    </v-snackbar>
    <v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          color="primary"
          fixed
          bottom
          left
          v-on="on"
          @click="$router.back()"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("repairLog.backbtn") }}</span>
    </v-tooltip>

    <v-card v-if="equipmentProfile">
      <v-card-title
        class="primary white--text d-flex justify-center text-center text-uppercase"
        >{{ $t("repairLog.title") }}</v-card-title
      >
      <v-form dark ref="form" v-model="valid" lazy-validation>
        <v-container>
          <v-row justify="center" align="center">
            <v-col cols="12" sm="12" justify="center" align="center">
              <v-text-field
                filled
                readonly=""
                v-model="equipmentProfile.equipTag"
                :label="$t('repairLog.tag')"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="12" justify="center" align="center">
              <v-text-field
                filled
                :rules="requireRules"
                readonly=""
                v-model="user.email"
                :label="$t('repairLog.createdby')"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider></v-divider>

          <v-row>
            <v-col cols="12" justify="center" align="center">
              <v-textarea
                clearable
                clear-icon="mdi-cancel"
                counter
                :rules="requireRules"
                row-height="30"
                filled
                v-model="repairProfile.log"
                :label="$t('repairLog.log')"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-divider></v-divider>
          <v-btn
            block
            x-large
            color="primary"
            class="elevation-8 font-weight-bold mr-4"
            :disabled="!valid"
            @click="validate"
            >{{ $t("repairLog.submitbtn") }}</v-btn
          >
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import { db, timestamp } from "@/plugins/db";
import { mapState } from "vuex";
export default {
  components: {},
  data: () => ({
    snackbar: false,
    valid: false,
    repairProfile: { log: "" },
    requireRules: [v => !!v || "This field is mandatory."],
    equipmentTypeRules: [v => !!v || "Asset Type is mandatory."]
  }),
  computed: {
    ...mapState("equipments", ["equipmentProfile"]),
    ...mapState("auth", ["user"])
  },
  async created() {
    const loading = this.$vs.loading({
      background: "#730D0B",
      color: "rgb(255, 255, 255)",
      opacity: 1,
      type: "square"
    });
    await this.$store.dispatch(
      "equipments/bindAnEquipment",
      this.$route.params.equipId
    );
    loading.close();
  },
  methods: {
    async validate() {
      const res = await this.$dialog.confirm({
        text: this.$t("dashboard.canYouConfirm"),
        title: this.$t("dashboard.checkFields")
      });
      if (res == true) {
        const loading = this.$vs.loading({
          background: "#730D0B",
          color: "rgb(255, 255, 255)",
          opacity: 1,
          type: "square"
        });

        let payload = {
          db: "repairs",
          data: {
            disabled: false,
            dateCreated: timestamp,
            createdBy: this.user.email,
            equipmentProfile: db
              .collection("equipments")
              .doc(this.equipmentProfile.id),
            log: this.repairProfile.log,
            type: "REPAIR"
          }
        };
        try {
          if (window.navigator.onLine) {
            let responseUid = await this.$store.dispatch(
              "addDocument",
              payload
            );

            loading.close();
            this.$router.push("/repair-profile/" + responseUid);
          } else {
            this.$store.dispatch("addDocument", payload);
            loading.close();
            this.$dialog.notify.warning(
              "You are offline, therefore your repair log will be sent to the database when you regain the connection. Redirecting to Asset Profile..",
              {
                position: "top-right",
                timeout: 5000
              }
            );
            setTimeout(() => {
              this.$router.push("/equipment/" + this.equipmentProfile.id);
            }, 4000);
          }
        } catch (error) {
          this.$dialog.notify.error(error, {
            position: "top-right",
            timeout: 5000
          });
        }
        loading.close();
      }
    }
  }
};
</script>

<style></style>
